// extracted by mini-css-extract-plugin
module.exports = {"items":"Positions-module--items--3X1xF","newsTitle":"Positions-module--newsTitle---bp1R","button":"Positions-module--button--2r4ml"};